module.exports = __webpack_public_path__ + "static/gm-20-3bd827ff25ad095c2842d3ede3a93558.jpg";